
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/not-found",
      function () {
        return require("private-next-pages/not-found.tsx");
      }
    ]);
  